import { Book } from 'lucide-react';
import { useMemo } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import { Datatable } from '@@/datatables';
import { useTableStateWithStorage } from '@@/datatables/useTableState';

import { Repository } from './types';
import { createColumns } from './columns';

export function RepositoriesDatatable({
  dataset,
  isLoading,
  repositoriesQuery,
}: {
  dataset?: Repository[];
  isLoading: boolean;
  repositoriesQuery: UseQueryResult<Repository[]>;
}) {
  const tableState = useTableStateWithStorage('registryRepositories');

  const columns = useMemo(
    () =>
      createColumns({
        isLoading: repositoriesQuery.isLoading,
        isFetching: repositoriesQuery.isFetching,
      }),
    [repositoriesQuery.isLoading, repositoriesQuery.isFetching]
  );

  return (
    <Datatable
      title="Repositories"
      titleIcon={Book}
      columns={columns}
      dataset={dataset || []}
      isLoading={isLoading}
      settingsManager={tableState}
      disableSelect
      data-cy="registry-repositories-datatable"
    />
  );
}
